import { DateTime } from "luxon";
import React from "react";
import { Link, useHistory } from "react-router-dom";
import styles from "./styles.module.scss";
import RoundButton from "app/components/Programs/Buttons/RoundButton";
import { useTranslation } from "react-i18next";

const ReportItem = ({ report, setCurrentReport, setOpenHistoryModal }) => {
  const history = useHistory();
  const { t } = useTranslation();

  let lastDownload: string;
  if (report.lastDownload) {
    lastDownload = DateTime.fromISO(report.lastDownload).toLocaleString(
      DateTime.DATE_FULL,
    );
  } else {
    lastDownload = "N/A";
  }

  let borderColorClass;

  switch (report.category) {
    case "Utilization":
      borderColorClass = styles.utilization_type_row;
      break;
    case "Activity":
      borderColorClass = styles.activity_type_row;
      break;
  }

  return (
    <div
      className={`${styles.item_container} ${borderColorClass} text-primary-text`}
    >
      <Link to={`/reports/${report.id}`} className={styles.title_width}>
        <span className={`${styles.bold_text} ${styles.cursor_pointer}`}>
          {t(report.title)}
        </span>
      </Link>
      <span className={`${styles.category_width}`}>{t(report.category)}</span>
      <span className={`${styles.downloaded_width}`}>{lastDownload}</span>
      <div className={`${styles.actions_width}`}>
        <div className={`${styles.action_container} `}>
          <RoundButton
            onClick={() => (
              setCurrentReport(report),
              setOpenHistoryModal(true)
            )}
            customStyle={styles.action_button}
          >
            {t("History")}
          </RoundButton>
          <RoundButton
            onClick={() => history.push(`/reports/${report.id}`)}
            customStyle={styles.action_button}
          >
            {t("View")}
          </RoundButton>
        </div>
      </div>
    </div>
  );
};

export default ReportItem;
